import { ComposeEmailModal as ComposeEmailModalComponent } from './ComposeEmailModal';

export const ComposeEmailModal = ComposeEmailModalComponent;
